
// theme-rhea-like.ts v19

// import { definePreset, palette } from '@primeuix/themes';
// import Material from '@primeuix/themes/dist/material';

// export const RheaLike = definePreset(Material, {
//   semantic: {
//     fontFamily:
//       'system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif',
//     text: {
//       color: '{zinc.900}',
//       secondaryColor: '{zinc.600}',
//     },
//     primary: palette('{indigo}'),
//     surface: {
//       0: '{surface.0}',
//       50: '{zinc.50}',
//       100: '{zinc.100}',
//       200: '{zinc.200}',
//       300: '{zinc.300}',
//       400: '{zinc.400}',
//       500: '{zinc.500}',
//       border: '{zinc.200}',
//       hover: '{zinc.100}',
//       ground: '{zinc.50}',
//       section: '{zinc.50}',
//       card: '{surface.0}',
//       overlay: '{surface.0}',
//     },
//     focusRing: {
//       color: '{blue.400}',
//       shadow: '0 0 0 0.2rem rgba(59, 130, 246, .25)',
//     },
//     link: {
//       color: '{blue.600}',
//       hoverColor: '{blue.700}',
//       activeColor: '{blue.800}',
//     },
//     highlight: {
//       background: '{blue.50}',
//       textColor: '{blue.900}',
//     },
//   },

//   components: {
//     button: {
//       color: '{primary.color}',
//       background: '{primary.500}',
//       borderColor: '{primary.500}',
//       hoverBackground: '{primary.600}',
//       hoverBorderColor: '{primary.600}',
//       textColor: '{primary.textColor}',
//       borderRadius: '4px',
//     },

//     inputtext: {
//       background: '{surface.card}',
//       borderColor: '{surface.border}',
//       color: '{text.color}',
//       hoverBorderColor: '{blue.400}',
//       focusBorderColor: '{blue.500}',
//       borderRadius: '4px',
//     },

//     panel: {
//       headerBackground: '{surface.0}',
//       headerColor: '{text.color}',
//       contentBackground: '{surface.card}',
//       contentColor: '{text.color}',
//       borderColor: '{surface.border}',
//       headerBorderColor: '{surface.border}',
//     },

//     menu: {
//       background: '{surface.card}',
//       borderColor: '{surface.border}',
//       item: {
//         color: '{text.color}',
//         hoverBackground: '{surface.hover}',
//         activeBackground: '{blue.50}',
//         activeColor: '{blue.700}',
//       },
//     },

//     datatable: {
//       headerBackground: '{surface.0}',
//       headerColor: '{text.color}',
//       borderColor: '{surface.border}',
//       rowHoverBackground: '{surface.hover}',
//       stripedBackground: '{zinc.50}',
//     },

//     elevation: {
//       1: '0 1px 2px rgba(0,0,0,.06)',
//       2: '0 2px 8px rgba(0,0,0,.08)',
//     },
//     radii: {
//       md: '4px',
//       lg: '6px',
//     },
//     tabs: {
//       header: {
//         background: '{surface.0}',          
//         color: '{text.color}',
//         borderColor: '{surface.border}',
//         padding: '.375rem .5rem',
//         borderRadius: '4px',
//       },

//       tab: {
//         background: '#768f9c',              
//         color: '#ffffff',
//         borderColor: '{surface.border}',
//         borderRadius: '4px',
//         padding: '.75rem .75rem',
//         fontWeight: '100',

//         hover: {
//           background: '#6f8693',            
//           color: '#ffffff',
//           borderColor: '{surface.border}',
//         },

//         active: {
//           background: '#b7d8cc',            
//           color: '#1f2d30',
//           borderColor: '#b7d8cc',
//           fontWeight: '100',
//         },
//       },

//       panel: {
//         background: '{surface.card}',
//         color: '{text.color}',
//         borderColor: '{surface.border}',
//         borderRadius: '4px',
//         padding: '1rem',
//       },
//     },
//   },
// });

// export default RheaLike;


// theme-rhea-like.ts v20
import { definePreset, palette } from '@primeuix/themes';
import Material from '@primeuix/themes/material';
// ⬇️ Pull the official token types so TS can tell you the valid keys.
import type { ComponentsDesignTokens } from '@primeuix/themes/types';

export const RheaLike = definePreset(Material, {
  /* ---------------------------------------------------
   * SEMANTIC TOKENS
   * --------------------------------------------------- */
  semantic: {
    fontFamily:
      'system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif',

    text: {
      color: '{zinc.900}',
      secondaryColor: '{zinc.600}',
      fontweight: '400',
    },

    primary: palette('{indigo}'),

    surface: {
      0: '{surface.0}',
      50: '{zinc.50}',
      100: '{zinc.100}',
      200: '{zinc.200}',
      300: '{zinc.300}',
      400: '{zinc.400}',
      500: '{zinc.500}',
      border: '{zinc.200}',
      hover: '{zinc.100}',
      ground: '{zinc.50}',
      section: '{zinc.50}',
      card: '{surface.0}',
      overlay: '{surface.0}',
    },

    focusRing: {
      color: '{blue.400}',
      shadow: '0 0 0 0.2rem rgba(59, 130, 246, .25)',
    },

    link: {
      color: '{blue.600}',
      hoverColor: '{blue.700}',
      activeColor: '{blue.800}',
    },

    highlight: {
      // Some versions expect highlight.background + highlight.color
      // Others expect highlight.backgroundColor + highlight.color
      // Keep names exactly as your TS types suggest.
      background: '{blue.50}',
      color: '{blue.900}',
    },

    // Optional: prefer component overrides via colorScheme to win specificity
    // when base preset reassigns variables later. See docs & community threads.
    colorScheme: {
      light: {
        // Example: button primary/hover via colorScheme has stronger precedence.
        // Use IDE completion to see available sections.
        button: {
          // If your types expose `primary`, use:
          // primary: { background: '{primary.500}', color: '{primary.textColor}' }
        },
      },
      // dark: { ... } // add if you support dark mode
    },
  },

  /* ---------------------------------------------------
   * COMPONENT TOKENS
   * --------------------------------------------------- */
  components: ((): ComponentsDesignTokens => ({

    /**
     * Button
     */


// button: {
//   root: {
//     borderRadius: '4px'
//   },

//   primary: {
//     background: '{primary.500}',
//     color: '{primary.textColor}',
//     borderColor: '{primary.500}',

//     hover: {
//       background: '{primary.600}',
//       borderColor: '{primary.600}',
//     },

//     focus: {
//       ringColor: '{focusRing.color}',
//       ringShadow: '{focusRing.shadow}',
//     }
//   }
// },




    /**
     * InputText
     */
    inputtext: {
      // Usually allowed in most builds
      // background: '{surface.card}',
      // color: '{text.color}',
      // borderColor: '{surface.border}',
      // borderRadius: '4px',
      // hover: { borderColor: '{blue.400}' },
      // focus: { borderColor: '{blue.500}' },
      // invalid: { borderColor: '{red.400}' },
      // fontWeight: '400',
    },

    /**
     * Card
     * Some versions use card.content (instead of body) for text styles.
     */
    card: {
      colorScheme: {
          light: {
              root: {
                  background: '{surface.0}',
                  color: '{surface.700}'
              },
              subtitle: {
                  color: '{surface.500}'
              }
          },
          dark: {
              root: {
                  background: '{surface.900}',
                  color: '{surface.0}'
              },
              subtitle: {
                  color: '{surface.400}'
              }
          }
      }
    },


  picklist: {
    // item:   { fontWeight: '400' },
    // header: { fontWeight: '400' },
    // filter: { fontWeight: '400' },
    // button: { label: { fontWeight: '400' } },
  },


    /**
     * Menu
     */

// menu: {
//   root: {
//     background: '{surface.card}',
//     borderColor: '{surface.border}'
//   },

//   item: {
//     color: '{text.color}',

//     hover: {
//       background: '{surface.hover}'
//     },

//     active: {
//       background: '{blue.50}',
//       color: '{blue.700}'
//     }
//   }
// },

    /**
     * DataTable
     */

// datatable: {
//   root: {
//     borderColor: '{surface.border}'
//   },

//   headerCell: {
//     background: '{surface.0}',
//     color: '{text.color}',
//     borderColor: '{surface.border}'
//   },

//   columnTitle: {
//     color: '{text.color}'
//   },

//   row: {
//     hover: {
//       background: '{surface.hover}'
//     },

//     striped: {
//       background: '{zinc.50}'
//     }
//   },

//   bodyCell: {
//     background: '{surface.card}',
//     color: '{text.color}',
//     borderColor: '{surface.border}'
//   }
// },

    /**
     * Tabs
     * If 'tab.borderRadius' is disallowed, apply radius at 'header' or 'panel'
     * depending on your types.
     */
    tabs: {
      // header: {
      //   background: '{surface.0}',
      //   color: '{text.color}',
      //   borderColor: '{surface.border}',
      //   padding: '.375rem .5rem',
      //   borderRadius: '4px',
      // },
      // tab: {
      //   background: '#768f9c',
      //   color: '#ffffff',
      //   borderColor: '{surface.border}',
      //   // omit borderRadius if not allowed on Tab
      //   padding: '.75rem .75rem',
      //   // Some versions provide flattened hover/active keys:
      //   // hoverBackground: '#6f8693',
      //   // hoverColor: '#ffffff',
      //   // activeBackground: '#b7d8cc',
      //   // activeColor: '#1f2d30',
      //   // activeBorderColor: '#b7d8cc',
      // },
      // panel: {
      //   background: '{surface.card}',
      //   color: '{text.color}',
      //   borderColor: '{surface.border}',
      //   borderRadius: '4px',
      //   padding: '1rem',
      // },
    },

    /**
     * Elevation & Radii (generally consistent across versions)
     */
    elevation: {
      1: '0 1px 2px rgba(0,0,0,.06)',
      2: '0 2px 8px rgba(0,0,0,.08)',
    },

    radii: {
      md: '4px',
      lg: '6px',
    },
  }))(),
});

export default RheaLike;

